import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { APPLICATION_ROUTES } from '@/constants/applicationRoutes';
import { useAuth } from '@/hooks/useAuth';
import { buildNameInitials } from '@/lib/nameInitials';

export function ProfileMenu() {
  const { t } = useTranslation(['admin', 'common']);
  const navigate = useNavigate();
  const { currentUser, logOut } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const displayName = currentUser === null ? '' : currentUser.fullName;

  function openProfile() {
    setIsMenuOpen(false);
    navigate(APPLICATION_ROUTES.adminProfile);
  }

  function handleLogout() {
    setIsMenuOpen(false);
    logOut();
  }

  return (
    <div className="relative">
      {isMenuOpen === true ? (
        <button
          type="button"
          aria-label={t('common:actions.close')}
          className="fixed inset-0 z-10 cursor-default"
          onClick={function closeMenu() {
            setIsMenuOpen(false);
          }}
        />
      ) : null}

      {isMenuOpen === true ? (
        <div
          role="menu"
          className="absolute bottom-full left-0 right-0 mb-2 z-20 bg-zoowhite border border-zooborder rounded-xl shadow-lg overflow-hidden"
        >
          <button
            type="button"
            role="menuitem"
            onClick={openProfile}
            className="w-full flex items-center gap-3 px-4 py-3 text-sm text-zooindigo hover:bg-zoovpalelavender transition-colors"
          >
            <Icon name="UserRound" className="text-zooviolet" />
            {t('admin:navigation.profile')}
          </button>
          <button
            type="button"
            role="menuitem"
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-3 text-sm text-zooerrortext hover:bg-zooerrorbg transition-colors border-t border-zooborder"
          >
            <Icon name="LogOut" />
            {t('common:actions.logout')}
          </button>
        </div>
      ) : null}

      <button
        type="button"
        aria-haspopup="menu"
        aria-expanded={isMenuOpen}
        onClick={function toggleMenu() {
          setIsMenuOpen(isMenuOpen === false);
        }}
        className="relative z-0 w-full flex items-center gap-3 p-4 border-t border-white/10 hover:bg-white/5 transition-colors text-left"
      >
        <div className="w-9 h-9 rounded-full bg-zooviolet text-zoowhite flex items-center justify-center font-bold text-xs shrink-0">
          {buildNameInitials(displayName)}
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold text-zoowhite truncate">{displayName}</div>
          <div className="text-[10px] text-white/50">{t('admin:role.platformAdmin')}</div>
        </div>
        <Icon name="ChevronRight" className="text-white/40 -rotate-90" />
      </button>
    </div>
  );
}
